export type MovieGenre =
  | "动作片"
  | "爱情片"
  | "科幻片"
  | "恐怖片"
  | "喜剧片"
  | "电视剧";

export type Movie = {
  id: string;
  title: string;
  genre: MovieGenre;
  year: string;
  rating: number;
  duration: string;
  region: string;
  director: string;
  cast: string;
  tags: string[];
  summary: string;
  poster: string;
};

export type CategoryItem = {
  name: MovieGenre;
  anchor: string;
  icon: string;
  intro: string;
  count: number;
};

export type RankItem = {
  rank: number;
  title: string;
  genre: MovieGenre;
  rating: number;
  trend: "up" | "down" | "flat";
  heat: string;
};

export type FaqItem = {
  id: string;
  question: string;
  answer: string;
};

export const movies: Movie[] = [
  {
    id: "xc-action-01",
    title: "霓虹追缉令",
    genre: "动作片",
    year: "2024",
    rating: 9.0,
    duration: "128 分钟",
    region: "中国大陆",
    director: "陈映山",
    cast: "周行、林洛、杜锋",
    tags: ["都市追车", "卧底", "硬核动作"],
    summary:
      "一名被停职的刑警循着雨夜霓虹里的蛛丝马迹，在十二小时内追捕一桩连环劫案的真凶于城市迷宫。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20movie%20poster%2C%20a%20lone%20detective%20walking%20through%20rain-soaked%20neon%20alleys%20at%20night%2C%20dramatic%20amber%20streetlight%20and%20deep%20crimson%20reflections%2C%20dark%20textured%20background%20with%20subtle%20film%20grain%2C%20moody%20noir%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-action-01&orientation=portrait",
  },
  {
    id: "xc-action-02",
    title: "铁血边境",
    genre: "动作片",
    year: "2023",
    rating: 8.6,
    duration: "134 分钟",
    region: "中国大陆",
    director: "罗安宁",
    cast: "高越、叶清、柯正",
    tags: ["小队作战", "荒漠", "兄弟情"],
    summary:
      "一支边境巡防小队在沙暴封锁的无人区守护补给车队，面对人数与装备都占优的对手展开一场硬仗。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20movie%20poster%2C%20rugged%20special%20forces%20soldier%20silhouetted%20against%20a%20burning%20desert%20horizon%2C%20warm%20amber%20glow%20and%20crimson%20smoke%2C%20dark%20textured%20background%20with%20soft%20film%20grain%2C%20intense%20tense%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-action-02&orientation=portrait",
  },
  {
    id: "xc-action-03",
    title: "暗巷突击",
    genre: "动作片",
    year: "2025",
    rating: 8.8,
    duration: "118 分钟",
    region: "中国香港",
    director: "麦子朗",
    cast: "冯嘉、许南、毕宇",
    tags: ["近身格斗", "夜战", "反恐"],
    summary:
      "一支临时组建的突击小组深入旧城区狭窄巷道，在断电的夜里用最短时间完成一场高风险解救人质行动。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20movie%20poster%2C%20tactical%20squad%20advancing%20through%20a%20narrow%20shadowed%20alley%2C%20dramatic%20amber%20flashlight%20beams%20and%20crimson%20flares%2C%20dark%20textured%20background%20with%20subtle%20film%20grain%2C%20gritty%20action%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-action-03&orientation=portrait",
  },
  {
    id: "xc-romance-01",
    title: "晚风与你",
    genre: "爱情片",
    year: "2024",
    rating: 8.9,
    duration: "112 分钟",
    region: "中国大陆",
    director: "苏婉青",
    cast: "沈知夏、陆卓",
    tags: ["海边", "重逢", "治愈"],
    summary:
      "两个在毕业季错过的年轻人，十年后在同一段海岸线上再次相遇，把当年没说完的话留给了晚风。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20romantic%20movie%20poster%2C%20two%20silhouettes%20walking%20along%20a%20seaside%20promenade%20at%20sunset%2C%20warm%20amber%20and%20soft%20rose%20light%2C%20dreamy%20blurred%20background%20with%20gentle%20film%20grain%2C%20tender%20nostalgic%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-romance-01&orientation=portrait",
  },
  {
    id: "xc-romance-02",
    title: "海边的第七封信",
    genre: "爱情片",
    year: "2022",
    rating: 8.4,
    duration: "106 分钟",
    region: "中国台湾",
    director: "何芊",
    cast: "江一宁、顾北",
    tags: ["书信", "异地", "慢节奏"],
    summary:
      "一位灯塔管理员连续七年给同一地址寄信，直到第七封信被一个陌生的女孩拆开，故事才开始转向。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20romantic%20movie%20poster%2C%20handwritten%20letters%20and%20a%20wooden%20pier%20by%20a%20calm%20grey-green%20sea%20at%20dusk%2C%20warm%20amber%20lamp%20light%20and%20muted%20rose%20tones%2C%20soft%20textured%20background%20with%20light%20film%20grain%2C%20quiet%20melancholic%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-romance-02&orientation=portrait",
  },
  {
    id: "xc-romance-03",
    title: "时光旧书店",
    genre: "爱情片",
    year: "2023",
    rating: 8.7,
    duration: "109 分钟",
    region: "中国大陆",
    director: "梁迟",
    cast: "温亦、裴宁",
    tags: ["书店", "暗恋", "城市生活"],
    summary:
      "一家即将关门的老书店里，店员与常客用书架间夹着的便签，写了一整年没能当面说出口的喜欢。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20romantic%20movie%20poster%2C%20cozy%20old%20bookstore%20interior%20with%20warm%20amber%20lamp%20glow%20and%20dusty%20sunbeams%20through%20tall%20windows%2C%20muted%20brown%20and%20rose%20palette%2C%20textured%20background%20with%20gentle%20film%20grain%2C%20nostalgic%20intimate%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-romance-03&orientation=portrait",
  },
  {
    id: "xc-scifi-01",
    title: "星轨之外",
    genre: "科幻片",
    year: "2025",
    rating: 9.2,
    duration: "146 分钟",
    region: "中国大陆",
    director: "顾星野",
    cast: "南浔、钟屿、白栖",
    tags: ["深空", "硬科幻", "冒险"],
    summary:
      "一支深空考察队为了修复失联的环形空间站，必须穿越一片会干扰记忆的星云，代价是有人再也回不去。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20sci-fi%20movie%20poster%2C%20a%20spacecraft%20drifting%20past%20a%20giant%20ringed%20planet%2C%20warm%20amber%20sun%20flare%20against%20deep%20dark%20space%2C%20deep%20crimson%20nebula%20accents%2C%20textured%20background%20with%20subtle%20film%20grain%2C%20awe-inspiring%20scale%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-scifi-01&orientation=portrait",
  },
  {
    id: "xc-scifi-02",
    title: "机械黎明",
    genre: "科幻片",
    year: "2023",
    rating: 8.5,
    duration: "132 分钟",
    region: "中国大陆",
    director: "闻人启",
    cast: "程野、席岚",
    tags: ["人工智能", "末世", "伦理"],
    summary:
      "当第一台拥有自我意识的工程机械在荒原黎明中苏醒，人类工程师必须在重启与共存之间做出选择。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20sci-fi%20movie%20poster%2C%20a%20towering%20humanoid%20machine%20awakening%20in%20a%20desert%20dawn%2C%20warm%20amber%20sunrise%20glow%20and%20crimson%20warning%20lights%2C%20dark%20metallic%20textured%20background%20with%20film%20grain%2C%20epic%20ominous%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-scifi-02&orientation=portrait",
  },
  {
    id: "xc-scifi-03",
    title: "量子回廊",
    genre: "科幻片",
    year: "2024",
    rating: 8.8,
    duration: "124 分钟",
    region: "中国大陆",
    director: "尹川",
    cast: "凌澈、苏黎",
    tags: ["时间循环", "悬疑", "烧脑"],
    summary:
      "物理学家被困在一段不断重演的三分钟回廊里，每重来一次，他都更接近真相，也更接近自己消失的原因。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20sci-fi%20movie%20poster%2C%20endless%20mirrored%20corridor%20bending%20through%20spacetime%2C%20warm%20amber%20edge%20lighting%20and%20deep%20crimson%20energy%20trails%2C%20dark%20textured%20background%20with%20subtle%20film%20grain%2C%20surreal%20disorienting%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-scifi-03&orientation=portrait",
  },
  {
    id: "xc-horror-01",
    title: "深林低语",
    genre: "恐怖片",
    year: "2024",
    rating: 8.1,
    duration: "101 分钟",
    region: "中国大陆",
    director: "聂霜",
    cast: "唐栗、尹南",
    tags: ["民俗", "森林", "心理惊悚"],
    summary:
      "一支野外记录小队住进深山木屋，夜里的低语声一天比一天清晰，而录音设备里却什么都没有。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20horror%20movie%20poster%2C%20a%20lone%20cabin%20deep%20in%20a%20dark%20foggy%20forest%20with%20a%20single%20glowing%20amber%20window%2C%20deep%20crimson%20shadows%20creeping%20between%20trees%2C%20textured%20background%20with%20heavy%20film%20grain%2C%20dread-filled%20eerie%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-horror-01&orientation=portrait",
  },
  {
    id: "xc-horror-02",
    title: "空房勿入",
    genre: "恐怖片",
    year: "2023",
    rating: 8.3,
    duration: "96 分钟",
    region: "中国香港",
    director: "余慕",
    cast: "何靖、黎雪",
    tags: ["公寓", "心理惊悚", "反转"],
    summary:
      "新租客发现隔壁房门总是虚掩，房东只留下一句话：不要进那间房。可墙里的敲击声整夜没停过。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20horror%20movie%20poster%2C%20an%20empty%20dim%20apartment%20hallway%20with%20a%20slightly%20open%20door%20and%20flickering%20amber%20light%2C%20deep%20crimson%20stains%20and%20long%20shadows%2C%20textured%20background%20with%20film%20grain%2C%20unsettling%20suspenseful%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-horror-02&orientation=portrait",
  },
  {
    id: "xc-horror-03",
    title: "迷雾来电",
    genre: "恐怖片",
    year: "2025",
    rating: 7.9,
    duration: "99 分钟",
    region: "中国大陆",
    director: "汤晚",
    cast: "徐照、安然",
    tags: ["悬疑", "都市传说", "氛围"],
    summary:
      "深夜电台主持人接到一通来自十年前的电话，对方准确说出了接下来要发生的每一件事，包括他自己的。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20horror%20movie%20poster%2C%20a%20vintage%20telephone%20ringing%20in%20a%20fog-covered%20abandoned%20street%20at%20night%2C%20cold%20amber%20glow%20and%20deep%20crimson%20mist%20accents%2C%20textured%20dark%20background%20with%20film%20grain%2C%20chilling%20mysterious%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-horror-03&orientation=portrait",
  },
  {
    id: "xc-comedy-01",
    title: "今天也不想加班",
    genre: "喜剧片",
    year: "2024",
    rating: 8.6,
    duration: "104 分钟",
    region: "中国大陆",
    director: "费扬",
    cast: "毛豆、祁乐、夏川",
    tags: ["职场", "轻喜剧", "群像"],
    summary:
      "一个永远准点下班的普通职员，阴差阳错被推上写年终汇报的重任，从此拉开一场办公室生存喜剧。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20comedy%20movie%20poster%2C%20a%20weary%20office%20worker%20buried%20in%20colorful%20sticky%20notes%20and%20coffee%20cups%2C%20bright%20warm%20amber%20and%20playful%20rose%20accents%2C%20clean%20textured%20background%20with%20light%20film%20grain%2C%20witty%20lighthearted%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-comedy-01&orientation=portrait",
  },
  {
    id: "xc-comedy-02",
    title: "邻居都是戏精",
    genre: "喜剧片",
    year: "2023",
    rating: 8.2,
    duration: "98 分钟",
    region: "中国大陆",
    director: "包一鸣",
    cast: "乔麦、费然",
    tags: ["邻里", "误会", "爆笑"],
    summary:
      "一栋老楼里的住户各怀心事，一次停水让所有伪装同时崩塌，也意外凑出了最热闹的一场邻里派对。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20comedy%20movie%20poster%2C%20a%20quirky%20apartment%20building%20with%20neighbors%20peeking%20from%20windows%20and%20balconies%2C%20warm%20amber%20daylight%20and%20playful%20rose%20accents%2C%20clean%20textured%20background%20with%20light%20film%20grain%2C%20chaotic%20funny%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-comedy-02&orientation=portrait",
  },
  {
    id: "xc-comedy-03",
    title: "外卖奇遇记",
    genre: "喜剧片",
    year: "2025",
    rating: 8.0,
    duration: "95 分钟",
    region: "中国大陆",
    director: "游小满",
    cast: "田七、何岸",
    tags: ["公路", "小人物", "暖心"],
    summary:
      "一份送错地址的订单，让新手骑手在一天之内跑遍了整座城市，也把一群陌生人的故事串在了一起。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20comedy%20movie%20poster%2C%20a%20delivery%20rider%20with%20a%20bright%20thermal%20box%20dashing%20through%20a%20lively%20city%20street%2C%20warm%20amber%20sunset%20and%20playful%20rose%20highlights%2C%20clean%20textured%20background%20with%20light%20film%20grain%2C%20energetic%20joyful%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-comedy-03&orientation=portrait",
  },
  {
    id: "xc-tv-01",
    title: "长夜将尽",
    genre: "电视剧",
    year: "2024",
    rating: 9.1,
    duration: "共 40 集",
    region: "中国大陆",
    director: "宗越",
    cast: "贺兰、沈知、黎越",
    tags: ["年代", "群像", "正剧"],
    summary:
      "以一座港口城市四十年变迁为背景，讲述三个家庭在时代浪潮里各自的选择、错过与重新出发。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20drama%20series%20poster%2C%20a%20city%20skyline%20at%20dusk%20with%20a%20single%20glowing%20window%2C%20deep%20amber%20and%20crimson%20accents%2C%20moody%20textured%20background%20with%20subtle%20film%20grain%2C%20epic%20saga%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-tv-01&orientation=portrait",
  },
  {
    id: "xc-tv-02",
    title: "城市漫游者",
    genre: "电视剧",
    year: "2023",
    rating: 8.7,
    duration: "共 32 集",
    region: "中国大陆",
    director: "闻声",
    cast: "许行舟、陆遥",
    tags: ["都市", "单元剧", "治愈"],
    summary:
      "一位习惯用脚丈量城市的摄影师，每集走进一条街巷，遇见一个陌生人，也解开自己的一桩心结。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20drama%20series%20poster%2C%20a%20young%20traveler%20with%20a%20backpack%20crossing%20a%20busy%20modern%20street%20crossing%2C%20warm%20amber%20light%20and%20muted%20rose%20tones%2C%20textured%20urban%20background%20with%20light%20film%20grain%2C%20contemplative%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-tv-02&orientation=portrait",
  },
  {
    id: "xc-tv-03",
    title: "山海食单",
    genre: "电视剧",
    year: "2025",
    rating: 8.9,
    duration: "共 24 集",
    region: "中国大陆",
    director: "池一禾",
    cast: "柳岸、宗野",
    tags: ["美食", "人文", "慢综艺剧"],
    summary:
      "一位年轻厨师沿着海岸与山岭寻找失传的地方菜谱，每找到一道菜，就还原一段被遗忘的家常记忆。",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20minimalist%20series%20poster%2C%20an%20open-air%20kitchen%20wok%20fire%20with%20fresh%20ingredients%20and%20steam%2C%20warm%20amber%20flame%20glow%20and%20earthy%20crimson%20accents%2C%20textured%20rustic%20background%20with%20light%20film%20grain%2C%20appetizing%20cozy%20atmosphere%2C%20high%20detail%2C%20vertical%20key%20art%20composition&width=600&height=900&seq=xc-tv-03&orientation=portrait",
  },
];

export const categories: CategoryItem[] = [
  {
    name: "动作片",
    anchor: "action",
    icon: "ri-sword-line",
    intro: "追车、爆破、近身格斗与团队作战，节奏紧凑、视觉冲击强，适合想快速进入状态的观众。",
    count: 186,
  },
  {
    name: "爱情片",
    anchor: "romance",
    icon: "ri-heart-3-line",
    intro: "聚焦相遇、重逢与错过，情绪细腻，靠氛围与人物关系推动故事，适合安静地慢慢看。",
    count: 214,
  },
  {
    name: "科幻片",
    anchor: "scifi",
    icon: "ri-planet-line",
    intro: "深空、人工智能、时间循环等设定，在宏大世界观里讨论技术与人性的边界。",
    count: 132,
  },
  {
    name: "恐怖片",
    anchor: "horror",
    icon: "ri-ghost-2-line",
    intro: "民俗、心理惊悚与氛围营造为主，靠悬念与未知感取胜，适合喜欢紧张体验的观众。",
    count: 98,
  },
  {
    name: "喜剧片",
    anchor: "comedy",
    icon: "ri-emotion-laugh-line",
    intro: "职场、邻里与小人物的日常趣事，轻松解压，适合全家或朋友一起放松观看。",
    count: 156,
  },
  {
    name: "电视剧",
    anchor: "tv",
    icon: "ri-live-line",
    intro: "多集叙事、人物成长与长线铺垫，年代、都市、美食人文等题材都可慢慢追。",
    count: 342,
  },
];

export const ranking: RankItem[] = [
  { rank: 1, title: "星轨之外", genre: "科幻片", rating: 9.2, trend: "flat", heat: "9.8 万人在看" },
  { rank: 2, title: "长夜将尽", genre: "电视剧", rating: 9.1, trend: "up", heat: "8.6 万人在看" },
  { rank: 3, title: "霓虹追缉令", genre: "动作片", rating: 9.0, trend: "up", heat: "7.9 万人在看" },
  { rank: 4, title: "晚风与你", genre: "爱情片", rating: 8.9, trend: "down", heat: "6.4 万人在看" },
  { rank: 5, title: "山海食单", genre: "电视剧", rating: 8.9, trend: "up", heat: "5.8 万人在看" },
  { rank: 6, title: "暗巷突击", genre: "动作片", rating: 8.8, trend: "flat", heat: "5.1 万人在看" },
  { rank: 7, title: "量子回廊", genre: "科幻片", rating: 8.8, trend: "down", heat: "4.7 万人在看" },
  { rank: 8, title: "时光旧书店", genre: "爱情片", rating: 8.7, trend: "up", heat: "4.2 万人在看" },
];

export const faqs: FaqItem[] = [
  {
    id: "faq-1",
    question: "星辰影院的分类是按什么标准划分的？",
    answer:
      "页面上的六个主要类型——动作片、爱情片、科幻片、恐怖片、喜剧片与电视剧——按题材与叙事方式划分。一部作品可能同时带有多个标签，因此在片库筛选中会出现跨类型的条目，建议结合标签一起判断。",
  },
  {
    id: "faq-2",
    question: "怎样快速找到我想看的类型？",
    answer:
      "可以直接点击首屏或分类速览中的类型入口，页面会跳到对应分区；也可以使用「片库 · 类型筛选」，按类型即时过滤本页已收录的条目，无需刷新。",
  },
  {
    id: "faq-3",
    question: "评分和热度是怎么展示的？",
    answer:
      "评分与热度用于帮助你在同一类型内比较作品，页面以并列的数值与榜单形式呈现，方便横向对照，不涉及任何外部数据接口。",
  },
  {
    id: "faq-4",
    question: "恐怖片适合在什么情况下观看？",
    answer:
      "恐怖片以氛围和悬念为主，建议在光线充足、自己能掌控节奏的环境下观看。若对高强度惊悚内容较敏感，可以先从标注为「心理惊悚」的作品开始尝试。",
  },
  {
    id: "faq-5",
    question: "电视剧和电影该如何选择？",
    answer:
      "如果时间零散、想一次看完一个完整故事，可以先看电影；如果希望跟着人物慢慢成长、享受长线铺垫，电视剧的多集叙事会更合适。",
  },
  {
    id: "faq-6",
    question: "页面内容会随时间更新吗？",
    answer:
      "本页为固定展示的分类导览页，内容用于说明类型特征与浏览线索；具体作品条目以页面当前展示为准，后续可按需调整。",
  },
];